module.exports = __webpack_public_path__ + "static/Chubb2-cd745739433ba003f8cf4fae1998e07d.png";